import { Autocomplete, TextField } from "@mui/material";

export default function TiposApuracaoAutocomplete({
  options,
  value,
  onChange,
  loading = false,
  disabled = false,
  error = false,
  helperText,
  sx,
  label = "Tipos de apuração",
  placeholder,
}) {
  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={(o) => o?.label ?? ""}
      isOptionEqualToValue={(a, b) =>
        a?.idRelatorio != null && b?.idRelatorio != null
          ? String(a.idRelatorio) === String(b.idRelatorio)
          : a === b
      }
      fullWidth
      size="small"
      loading={loading}
      disabled={disabled}
      noOptionsText={
        loading ? "Carregando…" : "Nenhum tipo de apuração encontrado"
      }
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
